<script>
import { Component, Vue, Prop, Ref } from "vue-property-decorator";
@Component({
  //   name: "multiline-button"
})
export default class multilineButton extends Vue {
  @Prop({ type: Array, default: () => [] }) options;
  @Prop({ type: String, default: "flex" }) type;
  @Prop({ type: String, default: "start" }) justify;
  @Prop({ type: String, default: "justify" }) align;

  render(h) {
    return (
      <el-row style="padding: 0 10px;" type={this.type} justify={this.justify} align={this.align}>
        {this.options.map(item => {
          const disabledIsFn = typeof item.disabled === "function";
          const loadingIsFn = typeof item.loading === "function";
          const isShow = typeof item.isShow === "function";
          return (isShow ? item.isShow() : true) && (
            <component
              {...{
                on: {
                  // onClick: item.handle,
                  click: item.handle
                },
                props: {
                  type: item.type,
                  disabled:
                    disabledIsFn === true ? item.disabled() : item.disabled,
                  loading:
                    loadingIsFn === true ? item.loading() : item.loading,
                  icon: item.icon,
                  size: item.size || "small",
                  powerName: item.powerName
                },
                style: item.style,
                is: item.controlName || "el-button"
              }}
            >
              {item.render ? item.render(h) : item.label}
            </component>
          );
        })}
      </el-row>
    );
  }
}
</script>
